import { useState } from 'react';
import Button from 'components/ui-components/Button';
import { SearchIcon, CircleXmark } from 'assets/icons';
import { white } from 'constants/variables';

const ApprovalsFilterGroups = ({
  filterGroupsHandler,
  statusList,
  currentSearchParam,
}) => {
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('Active');

  const searchHandler = e => {
    // Search on enter key press
    if (e.keyCode === 13) {
      filterGroupsHandler(search, status);
    }
    // Reset table when search is manually cleared
    if (e.target.value === '' && currentSearchParam.length > 0) {
      filterGroupsHandler('', status);
    }
    setSearch(e.target.value);
  };

  const clearSearchHandler = () => {
    setSearch('');
    if (currentSearchParam.length > 0) {
      filterGroupsHandler('', status);
    }
  };

  const statusHander = e => {
    filterGroupsHandler(search, e.target.value);
    setStatus(e.target.value);
  };

  return (
    <div className="fl mb-16">
      <div>
        <label htmlFor="name" className="ff-body fw-500 fs-12 tc-main">
          Search Groups
        </label>
        <div className="fl">
          <div className="approvals-search fl ai-c">
            <input
              id="name"
              className="width-100"
              name="name"
              type="search"
              placeholder="Search by group name"
              onChange={searchHandler}
              onKeyDown={searchHandler}
              value={search}
            />
            {search.length > 0 && (
              <Button
                type="button"
                label="Clear"
                handleClick={clearSearchHandler}
                className="approvals-search__clear">
                <CircleXmark width="20" height="20" />
              </Button>
            )}
          </div>
          <Button
            type="button"
            label="Search"
            className="approvals-search__btn"
            handleClick={() => filterGroupsHandler(search, status)}>
            <SearchIcon width="20" height="20" fillColor={white} />
          </Button>
        </div>
      </div>
      <div className="ml-8">
        <label htmlFor="status" className="ff-body fw-500 fs-12 tc-main">
          Group Status
        </label>
        <select
          id="status"
          name="status"
          className="approvals-select m-0"
          defaultValue="Active"
          onChange={statusHander}>
          {statusList.map(groupStatus => (
            <option value={groupStatus.label} key={groupStatus.label}>
              {groupStatus.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ApprovalsFilterGroups;
